import { render, staticRenderFns } from "./ClosedEye.vue?vue&type=template&id=8a23e712&scoped=true&"
import script from "./ClosedEye.vue?vue&type=script&lang=js&"
export * from "./ClosedEye.vue?vue&type=script&lang=js&"
import style0 from "./ClosedEye.vue?vue&type=style&index=0&id=8a23e712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a23e712",
  null
  
)

export default component.exports